import { render, staticRenderFns } from "./FormRequisites.vue?vue&type=template&id=724a6a26&"
import script from "./FormRequisites.vue?vue&type=script&lang=js&"
export * from "./FormRequisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports